<template>
    <div id="app">
        <transition name="slide-fade">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
export default {
    components: {},
    metaInfo: {
        htmlAttrs: { lang: 'es' },
        link: [
            { rel: 'apple-touch-icon', href: './assets/coaniquem-loading.png' },
        ],
    },
}
</script>

<style lang="scss">
:root {
    width: 100vw;
    font-size: 14px;
    scroll-behavior: smooth;
}
.debug {
    border: 1px black solid;
}
a.router-link-active,
a {
    color: white;
}
.slide-fade-enter-active {
    transition: all 2s ease;
}
.slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}

//  a.router-link-exact-active{
//   color:hsl(293, 58%, 49%);
// }
</style>
